module.exports = __webpack_public_path__ + "img/IMG-20200901-WA0017.cd951717.jpg";